// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tVdha","ant-typography":"styles_ant-typography__anzA2","logoContainer":"styles_logoContainer__2HTVm"};